import AmpleContainer from './Container'

export default AmpleContainer
